import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
/* src/app/page.members/view.scss: no such file or directory */`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];

    public search: any = {
        text: "",
        role: ""
    };

    public roles: any[] = [];

    public showInviteModal: boolean = false;
    public inviteData: any = { email: '', role: 'user' };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadRoles();
        await this.load();
    }

    public async loadRoles() {
        const { code, data } = await wiz.call("roles");
        if (code === 200) {
            this.roles = data || [];
        }
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list", this.search);
        if (code === 200) {
            this.members = data || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? "" : role;
        await this.load();
    }

    public async openInvite() {
        this.inviteData = { email: '', role: 'user' };
        this.showInviteModal = true;
        await this.service.render();
    }

    public async invite() {
        if (!this.inviteData.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }

        const { code, data } = await wiz.call("invite", this.inviteData);
        if (code === 200) {
            await this.service.modal.success("초대가 완료되었습니다.");
            this.showInviteModal = false;
            await this.load();
        } else {
            await this.service.modal.error(this.messageOf(data, "초대에 실패했습니다."));
        }
    }

    public async updateRole(member: any, role: string) {
        const previousRole = member.role;
        if (previousRole === role) return;

        member.role = role;
        await this.service.render();

        const { code, data } = await wiz.call("update_role", { id: member.id, role });
        if (code === 200) {
            Object.assign(member, data || {});
        } else {
            member.role = previousRole;
            await this.service.modal.error(this.messageOf(data, "역할 변경에 실패했습니다."));
        }
        await this.service.render();
    }

    public async removeMember(member: any) {
        let res = await this.service.modal.show({
            title: "멤버 제거",
            message: `${member.name}님을 멤버에서 제거하시겠습니까?`,
            action: "제거",
            actionBtn: "error",
            status: "error"
        });
        if (!res) return;

        const { code } = await wiz.call("remove", { id: member.id });
        if (code === 200) {
            await this.load();
        }
    }

    public roleClass(role: string) {
        switch (role) {
            case 'admin': return 'bg-purple-100 text-purple-700';
            case 'RECRUIT_ADMIN': return 'bg-indigo-100 text-indigo-700';
            case 'DOCUMENT_MANAGER': return 'bg-cyan-100 text-cyan-700';
            case 'REVIEWER': return 'bg-blue-100 text-blue-700';
            case 'BLIND_EVALUATOR': return 'bg-emerald-100 text-emerald-700';
            case 'AUDITOR': return 'bg-amber-100 text-amber-700';
            case 'READ_ONLY_VIEWER': return 'bg-slate-100 text-slate-700';
            case 'editor': return 'bg-blue-100 text-blue-700';
            case 'viewer': return 'bg-gray-100 text-gray-600';
            case 'user': return 'bg-zinc-100 text-zinc-600';
            default: return 'bg-gray-100 text-gray-600';
        }
    }

    public roleLabel(role: string) {
        const found = this.roles.find(item => item.value === role);
        return found?.label || role;
    }

    private messageOf(data: any, fallback: string) {
        if (typeof data === "string") return data;
        return data?.message || fallback;
    }
}

export default PageMembersComponent;